<template>
    <div class="contenedor_contenido">
        <div class="cabecera_contenido">

            <div v-if="permisos['inventarios.busqueda']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                class="btn_menu_contextual" :class="{ 'active': modulo === 'busqueda' }"
                @click="set_modulo('busqueda')">
                Búsqueda
            </div>

            <div v-if="permisos['inventarios.reportes']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                class="btn_menu_contextual" :class="{ 'active': modulo === 'reportes' }"
                @click="set_modulo('reportes')">
                Reportes
            </div>

            <div v-if="permisos['inventarios.rayo']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                class="btn_menu_contextual" :class="{ 'active': modulo === 'extras' }" @click="set_modulo('extras')">
                <i class="fas fa-bolt"></i>
            </div>
            <div v-if="permisos['inventarios.movimientos']?.ver || datos_usuario.parametros.roles.includes('ROOT')"
                class="btn_menu_contextual" :class="{ 'active': modulo === 'movimientos' }"
                @click="set_modulo('movimientos')">
                Movimientos
            </div>

            <div class="contenedor_spinner">
                <img v-if="this.$store.state.loading" src="@/assets/spinner.gif" alt="">
            </div>

        </div>

        <div class="contenido_">
            <Busqueda v-if="modulo == 'busqueda'" />
            <CrearArticulo v-if="modulo == 'crear_articulo'" />
            <Extras v-if="modulo == 'extras'" />
            <Movimientos v-if="modulo == 'movimientos'" />
            <Reportes v-if="modulo == 'reportes'" />
        </div>
        <!-- <Busqueda v-if="modulo == 'busqueda'" /> -->

    </div>
</template>

<script>

    import Busqueda from './Busqueda/Busqueda.vue'
    import CrearArticulo from './Articulo/CrearArticulo.vue'
    import Extras from './Extras/MenuExtras.vue'
    import Movimientos from './Movimientos/Movimiento.vue'
    import Reportes from './Reportes/MenuReportes.vue'
    import { mapState } from 'vuex'

    export default {
        name: 'MenuInventario',
        computed: {
            ...mapState(['permisos', 'datos_usuario'])
        },
        components: {
            Busqueda,
            CrearArticulo,
            Extras,
            Movimientos,
            Reportes
        },
        data() {
            return {
                modulo: 'busqueda'
            }
        },
        methods: {
            set_modulo(modulo) {
                this.modulo = modulo
            },
        },
        mounted() {

            if (this.permisos['inventarios.busqueda']?.ver) {
                this.modulo == 'busqueda'
            } else if (this.datos_usuario.parametros.roles.includes('ROOT')) {
                this.modulo = 'busqueda'
            } else {
                this.modulo = ''
            }
        },
    }
</script>

<style>
    .cabecera_contenido {
        display: flex;
        flex-direction: row;
        width: 100%;
    }

    .btn_menu_contextual {
        flex: 1;
        text-align: center;
        padding: 10px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    /* .btn_menu_contextual:hover {
        background-color: #f0f0f0;
    } */

    .btn_menu_contextual.active {
        background-color: #6a6969;
        font-weight: bold;
    }

    .contenedor_spinner {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>